/*
 * Where: src/components/organisms/SiteHeader.js
 * What: Organism component for global header and navigation.
 * Why: Keep layout-level header concerns in one reusable component.
 */
import React from 'react';
import NavButton from '../atoms/NavButton';
import { ROUTE_PATHS } from '../../constants/routes';

function SiteHeader({ currentPath, onNavigate }) {
    return (
        <header className="site-header">
            <div className="container header-inner">
                <div className="brand-block">
                    <p className="brand-label">NFC</p>
                    <div>
                        <p className="brand-title">行政支援レコメンド</p>
                        <p className="brand-subtitle">個人向け確認サイト</p>
                    </div>
                </div>
                <nav className="header-nav" aria-label="Main navigation">
                    <NavButton
                        label="トップ"
                        path={ROUTE_PATHS.top}
                        active={currentPath === ROUTE_PATHS.top}
                        onNavigate={onNavigate}
                    />
                    <NavButton
                        label="使い方"
                        path={ROUTE_PATHS.howToUse}
                        active={currentPath === ROUTE_PATHS.howToUse}
                        onNavigate={onNavigate}
                    />
                    <NavButton
                        label="読み取る"
                        path={ROUTE_PATHS.read}
                        active={currentPath === ROUTE_PATHS.read}
                        onNavigate={onNavigate}
                    />
                </nav>
            </div>
        </header>
    );
}

export default SiteHeader;
